import React from "react";
import HowItWorksWithSteps from "../../components/services/sections/HowItWorksWithSteps";
import TrustedBy from "../../components/services/sections/TrustedBy";
import NeedTranslation from "../../components/services/sections/NeedTranslation";
import WhatWhySections from "../../components/services/sections/WhatWhySections";
import BottomTranslation from "../../components/services/sections/BottomTranslation";
import {
  translationBottomData,
  translationHIWData,
  translationCardData,
  trustedByData,
} from "../../components/services/data";

const Translation = () => {
  return (
    <>
      <NeedTranslation />
      <WhatWhySections {...translationCardData} />
      <HowItWorksWithSteps withButton="true" {...translationHIWData} />
      <TrustedBy {...trustedByData} />
      <BottomTranslation {...translationBottomData} />
    </>
  );
};
export default Translation;
